export function deserialize<T>(cls: new () => T, data: any): T {
    return Object.assign(new cls(), data);
}

export function deserializeArray<T>(cls: new () => T, data: any[]): T[] {
    if (data === undefined) {
        return [];
    }
    return data.map((value) => deserialize<T>(cls, value));
}
